import React from "react";
import "./PrivacyPolicy.css";

const PrivacyPolicy = () => {
  return (
    <div className="privacy-policy">
      <h1>PRIVACY POLICY</h1>

      <p>
        Visioapps Technology Private Limited ("Company", "we", "our" or "us")
        is committed to protecting the privacy and personal information of
        individuals who visit our website, use Louie Voice and its related
        products and services, communicate with us, or apply for
        opportunities with the Company.
      </p>

      <p>
        This Privacy Policy explains how we collect, use, disclose, retain
        and protect personal information in connection with{" "}
        <a href="http://www.louievoice.com/" target="_blank" rel="noopener noreferrer">
          www.louievoice.com
        </a>{" "}
        and our products, services and business activities.
      </p>

      <p>
        By accessing our website, using our services, submitting information
        through our website, or otherwise providing personal information to
        us, you acknowledge the practices described in this Privacy Policy.
      </p>

      <h2>1. Information We Collect</h2>
      <p>
        Depending on how you interact with us, we may collect the following
        categories of personal information:
      </p>

      <h3>A. Information provided directly by you</h3>
      <p>This may include:</p>
      <ul>
        <li>Name, email address, telephone number and other contact details</li>
        <li>Company/organisation name and professional information</li>
        <li>
          Information submitted through contact, enquiry, demonstration or
          other forms
        </li>
        <li>
          Information provided when communicating with us by email or other
          channels
        </li>
        <li>
          Information required to provide products or services requested by
          you
        </li>
      </ul>

      <h3>B. Information relating to Louie Voice and our services</h3>
      <p>
        Where applicable, we may process information associated with the use
        of Louie Voice and its related products and services, including:
      </p>
      <ul>
        <li>Voice inputs and commands</li>
        <li>Device, operating system, browser and application information</li>
        <li>Usage and diagnostic information</li>
        <li>Information relating to interactions with our products and services</li>
        <li>
          Information necessary to process and fulfil requests made through
          our services
        </li>
      </ul>
      <p>
        The information collected may vary depending on the product, service,
        feature used and permissions enabled by the user or applicable
        customer configuration.
      </p>

      <h3>C. Information provided for employment opportunities</h3>
      <p>
        If you apply for a job or other opportunity through our website or
        recruitment process, we may collect information such as:
      </p>
      <ul>
        <li>Name and contact details</li>
        <li>Resume/CV</li>
        <li>Educational qualifications</li>
        <li>Employment and professional experience</li>
        <li>Skills, certifications and other professional information</li>
        <li>
          Information provided during interviews, assessments or recruitment
          discussions
        </li>
        <li>
          Any other information voluntarily provided as part of the
          recruitment process
        </li>
      </ul>
      <p>
        We collect recruitment-related information for the purpose of
        evaluating and managing applications and related employment or
        engagement processes.
      </p>

      <h3>D. Information collected automatically</h3>
      <p>
        When you visit our website, certain information may be collected
        automatically, including:
      </p>
      <ul>
        <li>IP address</li>
        <li>Browser type and version</li>
        <li>Device information</li>
        <li>Operating system</li>
        <li>Pages visited and interactions with the website</li>
        <li>Date, time and duration of visits</li>
        <li>General usage, diagnostic and technical information</li>
      </ul>
      <p>
        We may use cookies and similar technologies to operate, secure,
        analyse and improve our website and services.
      </p>

      <h2>2. Use of Personal Information</h2>
      <p>We may use personal information for the following purposes:</p>
      <ul>
        <li>To provide, operate and maintain our products and services</li>
        <li>To process user requests and voice commands, where applicable</li>
        <li>To respond to enquiries and requests for information</li>
        <li>To provide technical and customer support</li>
        <li>
          To communicate with customers, users, business contacts and
          website visitors
        </li>
        <li>
          To improve the performance, functionality, security and
          reliability of our website and services
        </li>
        <li>To understand website usage and improve user experience</li>
        <li>
          To detect, prevent and address security incidents, misuse, fraud
          or unauthorised activities
        </li>
        <li>To process and evaluate job applications and recruitment activities</li>
        <li>To maintain business, administrative and operational records</li>
        <li>
          To comply with applicable legal, regulatory and contractual
          requirements
        </li>
        <li>To protect our rights, property, systems and users</li>
        <li>
          For any other purpose communicated to you at the time of
          collection or otherwise permitted by applicable law
        </li>
      </ul>
      <p>
        We seek to collect and process only information that is reasonably
        necessary for the relevant purpose.
      </p>

      <h2>3. Legal Basis and Consent</h2>
      <p>
        Where required under applicable law, we will obtain appropriate
        consent before processing personal information.
      </p>
      <p>
        Where applicable, personal information may also be processed where
        necessary to provide a service requested by an individual, perform
        or enter into a contract, comply with a legal or regulatory
        obligation, or for other purposes permitted under applicable law.
      </p>
      <p>
        Where processing is based on consent, individuals may withdraw their
        consent, subject to applicable legal, contractual or technical
        requirements.
      </p>
      <p>
        Withdrawal of consent may affect our ability to provide certain
        products, services or functionality.
      </p>

      <h2>4. Sharing of Personal Information</h2>
      <p>We do not sell personal information.</p>
      <p>
        We may disclose or share personal information where reasonably
        necessary for legitimate business, contractual, operational or
        legal purposes, including with:
      </p>
      <ul>
        <li>Authorised service providers and technology providers</li>
        <li>Professional advisers, consultants and auditors</li>
        <li>Business partners where necessary to provide requested services</li>
        <li>Recruitment and assessment service providers, where applicable</li>
        <li>
          Government, regulatory or law-enforcement authorities where
          required or permitted by law
        </li>
        <li>
          Other parties where disclosure is necessary to protect our rights,
          security, property or users
        </li>
      </ul>
      <p>
        Third parties receiving personal information from us are expected to
        maintain appropriate confidentiality and security safeguards and to
        process information only for authorised purposes.
      </p>
      <p>
        We may also disclose information in connection with a merger,
        acquisition, restructuring, financing, sale of assets or other
        corporate transaction, subject to applicable law.
      </p>

      <h2>5. Cookies and Similar Technologies</h2>
      <p>Our website may use cookies and similar technologies to:</p>
      <ul>
        <li>Enable website functionality</li>
        <li>Maintain security</li>
        <li>Understand website traffic and usage</li>
        <li>Improve website performance and user experience</li>
        <li>Analyse interactions with our website and services</li>
      </ul>
      <p>
        You may be able to control or disable cookies through your browser
        settings. Disabling certain cookies may affect the functionality of
        parts of the website.
      </p>
      <p>
        Where required, we will seek appropriate consent before placing or
        using non-essential cookies or similar technologies.
      </p>

      <h2>6. Information Security</h2>
      <p>
        We maintain reasonable administrative, technical and organisational
        security measures designed to protect personal information against
        unauthorised access, disclosure, alteration, loss, misuse or
        destruction.
      </p>
      <p>
        Security measures may include appropriate access controls,
        authentication mechanisms, encryption or other safeguards as
        appropriate to the nature of the information and the relevant
        processing activities.
      </p>
      <p>
        However, no method of transmission or electronic storage can be
        guaranteed to be completely secure. Accordingly, while we take
        reasonable measures to protect personal information, we cannot
        guarantee absolute security.
      </p>

      <h2>7. Data Retention</h2>
      <p>
        We retain personal information only for as long as reasonably
        necessary to fulfil the purposes for which it was collected,
        provide requested services, meet contractual requirements, resolve
        disputes, maintain appropriate business records, or comply with
        applicable legal and regulatory obligations.
      </p>
      <p>
        Different categories of information may therefore be retained for
        different periods depending on the purpose and applicable
        requirements.
      </p>
      <p>
        When personal information is no longer required, we will take
        reasonable steps to securely delete, anonymise or otherwise dispose
        of it in accordance with applicable law and our internal practices.
      </p>

      <h2>8. Privacy Rights</h2>
      <p>
        Subject to applicable law, individuals may have rights relating to
        their personal information, including the right to:
      </p>
      <ul>
        <li>Request access to personal information held about them</li>
        <li>
          Request correction or updating of inaccurate or incomplete
          information
        </li>
        <li>Request deletion of personal information where legally applicable</li>
        <li>Withdraw consent where processing is based on consent</li>
        <li>Raise a grievance regarding the processing of personal information</li>
        <li>
          Exercise other rights available under applicable data-protection
          laws
        </li>
      </ul>
      <p>
        Requests will be handled in accordance with applicable legal and
        regulatory requirements.
      </p>
      <p>
        To protect privacy and security, we may take reasonable steps to
        verify the identity of an individual before processing a request.
      </p>

      <h2>9. Children's Personal Information</h2>
      <p>Our website and services are not specifically directed at children.</p>
      <p>
        Where personal information relating to individuals below the
        applicable age of majority is processed, we will take appropriate
        measures and obtain consent from a parent or lawful guardian where
        required by applicable law.
      </p>

      <h2>10. Third-Party Websites and Services</h2>
      <p>
        Our website may contain links to third-party websites, applications
        or services.
      </p>
      <p>
        This Privacy Policy does not apply to the privacy practices of third
        parties that we do not control. We encourage users to review the
        privacy policies of such third parties before providing them with
        personal information.
      </p>

      <h2>11. International Data Transfers</h2>
      <p>
        Depending on the nature of our services, business operations and
        technology infrastructure, personal information may be processed or
        stored in locations other than the location from which it was
        collected.
      </p>
      <p>
        Where personal information is transferred or processed across
        jurisdictions, we will take appropriate measures to comply with
        applicable data-protection, contractual and regulatory
        requirements.
      </p>

      <h2>12. Compliance</h2>
      <p>
        We seek to process personal information in accordance with
        applicable privacy, data-protection, information-security and
        cybersecurity requirements, including, as applicable:
      </p>
      <ul>
        <li>
          Digital Personal Data Protection Act, 2023 and applicable rules
          and regulations
        </li>
        <li>Information Technology Act, 2000 and applicable rules</li>
        <li>Applicable CERT-In directions and requirements</li>
        <li>Applicable contractual and regulatory requirements</li>
        <li>Relevant information-security practices and standards</li>
        <li>Other applicable statutory and regulatory requirements</li>
      </ul>
      <p>
        References to laws, regulations, standards or regulatory
        requirements in this Privacy Policy are subject to amendments,
        updates and replacements from time to time.
      </p>

      <h2>13. Changes to this Privacy Policy</h2>
      <p>
        We may update this Privacy Policy periodically to reflect changes in
        our products, services, business practices, technology or
        applicable legal and regulatory requirements.
      </p>
      <p>
        The updated Privacy Policy will be published on our website with the
        revised effective date.
      </p>
      <p>
        We encourage users to review this Privacy Policy periodically to
        remain informed about how we handle personal information.
      </p>

      <h2>14. Contact and Grievance Redressal</h2>
      <p>
        If you have any questions, concerns, requests or grievances relating
        to this Privacy Policy or the processing of your personal
        information, you may contact us using the details below:
      </p>
      <p>
        <strong>Visioapps Technology Private Limited</strong>
        <br />
        <strong>Louie Voice</strong>
        <br />
        Gurugram, Haryana, India
      </p>
      <p>
        <strong>Privacy / Grievance Contact:</strong>{" "}
        <a href="mailto:hello@visio-apps.com">hello@visio-apps.com</a>
      </p>
      <p>
        We will endeavour to address privacy-related requests and
        grievances within the timelines prescribed under applicable law.
      </p>
    </div>
  );
};

export default PrivacyPolicy;
